import React, { FC } from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'


export const GLDWZJ: FC<{ data: any }> = ({ data, ...props }) => {

	const option = {
		tooltip: {
			trigger: 'item',
			formatter: '{a} <br/>{b} : {c} ({d}%)'
		},
		legend: {
			type: 'scroll',
			orient: 'vertical',
			right: 10,
			top: 20,
			bottom: 20,
			data: data.map((item: { orgName: any; }) => item.orgName)
		},

		title: {
			// 主标题样式
			textStyle: {
				color: '#666',
				fontSize: 18,
			},
			itemGap: 10,
			x: 'center',
			y: 'center',
			text: `总量:${data.reduce((c: any, n: { orgNum: any; }) => { c = c + n.orgNum; return c; }, 0)}`,
			subtext: '',
			// 副标题样式
			subtextStyle: {
				color: '#666',
			},
			left: '10%',
			top: '0%'
			// left: '37%',
			// top: '46%'
		},
		label: {
			alignTo: 'edge',
			formatter: '{name|{b}}\n{time|{c}}',
			minMargin: 5,
			edgeDistance: 10,
			lineHeight: 15,
			rich: {
				time: {
					fontSize: 10,
					color: '#999'
				}
			},
		},
		series: [
			{
				name: '管理单位',
				type: 'pie',
				radius: ["35%", '65%'],
				center: ['40%', '50%'],
				// label: {
				// 	show: false,
				// 	position: 'center'
				// },
				// labelLine: {
				// 	show: false
				// },
				// emphasis: {//饼图中间显示配置
				// 	label: {
				// 		show: true,
				// 		fontSize: '14',
				// 		formatter: '{b} : {c} ({d}%)'
				// 	}
				// },
				data: data.map((item: { orgName: any; orgNum: number }) => ({ name: item.orgName, value: item.orgNum })),
				emphasis: {
					itemStyle: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: 'rgba(0, 0, 0, 0.5)'
					}
				}
			}
		]
	};

	return (
		<ReactEchartsCore
			className='wh100 hAuto'
			echarts={echarts}
			theme="pie"
			option={option as any}
		/>
	)
}